const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/portfolio/table/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { workIntegrationSearchSchema } from 'src/lib/zod-schemas/workIntegrationSearchSchema';
import { planQueryOptions } from '@/lib/queries/adaptive-planner/useGetPlansQuery';
import { getTeamsQueryOptions } from '@/lib/queries/teams/useGetTeamsQuery';
import i18n from '@/lib/translations/i18n';
import { parseCustomFieldSearchParams } from '@/lib/zod-schemas/common/filters';
import { descendantItemFilterSearchSchema } from '@/lib/zod-schemas/descendantItemFilterSearchSchema';
import { datetimeItemFilterSchema } from '@/lib/zod-schemas/itemFilterSearchSchema';
import { itemPanelSearchSchema } from '@/lib/zod-schemas/itemPanelSearchSchema';
import { portfolioQuickFilterSearchSchema } from '@/lib/zod-schemas/portfolioQuickFilterSearchSchema';
const portfolioTableSchema = workIntegrationSearchSchema.and(descendantItemFilterSearchSchema).and(itemPanelSearchSchema).and(datetimeItemFilterSchema).and(portfolioQuickFilterSearchSchema);
export const Route = createFileRoute('/(app)/org/$org/portfolio/table/')({
  validateSearch: (search: Record<string, unknown>): PortfolioTableRouteSearch => {
    const validated = zodValidator(portfolioTableSchema).parse(search) as PortfolioTableRouteSearch;
    const validatedCf = parseCustomFieldSearchParams(search);
    return Object.keys(validatedCf).length > 0 ? {
      ...validated,
      ...validatedCf
    } : validated;
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  loader: async ({
    context: {
      queryClient
    }
  }): Promise<LoaderData> => {
    await Promise.all([queryClient.ensureQueryData(getTeamsQueryOptions()), queryClient.ensureQueryData(planQueryOptions())]);
    return {
      crumb: i18n.t('roadmapping.visualizationType.itemGrid')
    };
  },
  staticData: {
    topNav: {
      title: i18n.t('portfolio.title')
    }
  }
});